module.exports = __webpack_public_path__ + "img/p3.6a21b3fc.png";